import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { MOCK_SEARCH_BUTTON } from './mock-search.button';

export const MOCK_SEARCH_PLUGIN_ID = 'mock-search';

export const MOCK_SEARCH_PLUGIN = new Plugin({
  id: MOCK_SEARCH_PLUGIN_ID,
  button: MOCK_SEARCH_BUTTON
});
